import { render, staticRenderFns } from "./couponHistory.vue?vue&type=template&id=4b4bf094&"
import script from "./couponHistory.vue?vue&type=script&lang=js&"
export * from "./couponHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports